<div class="w-full">
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>{{props.label}}</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [dateFilter]="props.filter" [min]="minSelectableDate">
      <input matStartDate [id]="startDateInputId" [attr.aria-label]="startDateLabel" formControlName="startDate" [placeholder]="props.placeholderStart" />
      <input matEndDate [id]="endDateInputId" [attr.aria-label]="endDateLabel" formControlName="endDate" [placeholder]="props.placeholderEnd"/>
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
    @if (range.controls.startDate.hasError('startDateInPast')) {
      <mat-error>Unavailability cannot start on a date in the past.</mat-error>
    }
  </mat-form-field>
</div>
